import {API_DRIVER} from "../config/axios";

interface IStartSession {
    order_id: string
    wish_id: string
    ticket_count: number
    recipient_email?: string
    recipient_name?: string
    personal_message?: string
}

const getPaymentsRequestUrl = (endpointUrl: string) => {
    return `/api/payments${endpointUrl}`
}

const PaymentService = {
    startSession: (body: IStartSession) => {
        return API_DRIVER.post(getPaymentsRequestUrl(`/session`), body)
    },
    checkOrder: (orderId: string) => {
        return API_DRIVER.get(getPaymentsRequestUrl(`/check/${orderId}`))
    }
}

export default PaymentService
